
<template>
  <div ref="scroll" class="layout-segment-scroll" :class="getIsPrint">
    <div ref="holder" class="layout-segment-holder">
      <LayoutSegment
        v-for="(segment, index) in getSegmentsByType"
        :key="'segment_' + getType + index"
        :num="index"
        :ref="'segment_' + getType + index"
        :remove="handleRemoveSegment"
        :expand="checkWidth"
        :type="type"
        :segment="segment"
        :data-num="index"
        @mouseover="handleMouseOver"
      ></LayoutSegment>
      <AddSegment v-show="getTypeLimit" @click="handleAddSegment" :type="type"/>
    </div>
  </div>
</template>

<script>
import LayoutSegment from '@/components/layout/LayoutSegment';
import AddSegment from '@/components/layout/AddSegment';
import { usePipeStore } from '@/store/PipeStore';
import { useSegmentStore } from '@/store/SegmentStore';
import { useInputStore } from '@/store/InputStore';
import { usePrintStore } from '@/store/PrintStore';

export default {
  data () {
    return {
      startMouseX: 0,
      startScrollX: 0,
      allSegmentsExpanded: true
    };
  },
  setup () {
    usePipeStore().getPipesData();
  },
  props: [
    'type'
  ],
  components: {
    LayoutSegment,
    AddSegment
  },
  watch: {
    getSelectedPipeNum (to, from) {
      if (this.type === 'pipe') {
        this.highlightSegment(to, from);
      }
    },
    getSelectedSlopeNum (to, from) {
      if (this.type === 'slope') {
        this.highlightSegment(to, from);
      }
    },
    getSegmentsByType: {
      handler () {
        this.checkWidth(0);
      },
      deep: true
    },
  },
  mounted () {
    this.$refs.scroll.addEventListener('mousedown', this.handleMouseDown);
    if (this.$props.type === 'pipe') {
      document.addEventListener('keyup', (event) => {
        if (event.key === 'p') {
          this.expandAll('pipe');
        }
      });
    }
    if (this.$props.type === 'slope') {
      document.addEventListener('keyup', (event) => {
        if (event.key === 's') {
          this.expandAll('slope');
        }
      });
    }
    window.t = this;
  },
  computed: {
    getSelectedPipeNum () {
      return useSegmentStore().getSelectedPipeNum;
    },
    getSelectedSlopeNum () {
      return useSegmentStore().getSelectedSlopeNum;
    },
    getSegmentsByType () {
      return useSegmentStore().getSegments(this.$props.type);
    },
    getType () {
      return this.$props.type;
    },
    getIsPrint () {
      return !usePrintStore().getPrintIsOpen ? '' : 'print-margin';
    },
    getTypeLimit () {
      return this.getSegmentsByType.length < 4 && !usePrintStore().getPrintIsOpen;
    }
  },
  methods: {
    expandAll (type) {
      let segments = this.getSegmentsByType;
      for (let a = 0; a < segments.length; a++) {
        let segment = this.$refs['segment_' + type + a];
        if (segment.length == 0) { continue; }
        if (!this.allSegmentsExpanded) {
          // segment[0].expandSegment();
        } else {
          // segment[0].closeSegment();
        }
      }
      this.allSegmentsExpanded = !this.allSegmentsExpanded;
    },
    highlightSegment (to, from) {
      if (from !== null) {
        let previousSelectedSegment = this.$refs['segment_' + this.getType + from];
        if (previousSelectedSegment[0] !== undefined) {
          previousSelectedSegment[0].$el.classList.remove('selected');
        }
      }
      if (to === null) { return; }
      let selectedSegment = this.$refs['segment_' + this.getType + to];
      selectedSegment[0].$el.classList.add('selected');
      this.autoScrollSegment(to);
    },
    autoScrollSegment (to) {
      let selectedSegment = this.$refs['segment_' + this.getType + to];
      let segmentLeft = selectedSegment[0].$el.getBoundingClientRect().left;
      let scrollWidth = this.$el.clientWidth;

      // behavior: "smooth",
      // todo: could make this scrolling by percentage from left/right

      const segmentStore = useSegmentStore();
      if (this.$props.type === 'pipe' && !segmentStore.getSelectedPipeFromEditor) { return; }
      if (this.$props.type === 'slope' && !segmentStore.getSelectedSlopeFromEditor) { return; }
      if ( segmentLeft > scrollWidth ) {
        this.$el.scrollTo({ left: scrollWidth + (scrollWidth - segmentLeft), top: 0, behavior:'auto' });
      } else {
        if (segmentLeft < scrollWidth * .3) {
          this.$el.scrollTo({ left: this.$el.scrollLeft - selectedSegment[0].$el.getBoundingClientRect().width, top: 0, behavior:'auto' });
        }
      }
    },
    handleAddSegment () {
      const segmentStore = useSegmentStore();
      segmentStore.addDefaultSegmentForType(this.$props.type);
      this.checkWidth();
      segmentStore.validateSlopeMinimumLength();
      // if (this.$props.type === 'slope') {
      //   segmentStore.extendFunc();
      // }
      useInputStore().sprinklerCalc();
    },
    handleAddPipe () {
      const segmentStore = useSegmentStore();
      segmentStore.addDefaultSegmentForType('pipe');
      this.checkWidth();
      segmentStore.validateSlopeMinimumLength();
      useInputStore().sprinklerCalc();
    },
    checkWidth (delay) {
      if (delay === undefined) { delay = 0; }
      setTimeout( () => {
        if (this.$refs.holder.clientWidth > this.$refs.scroll.clientWidth) {
          this.$refs.scroll.classList.add('taller');
        } else {
          this.$refs.scroll.classList.remove('taller');
        }
      }, delay);
    },
    handleRemoveSegment (num) {
      // todo: add prompt with overlay
      useSegmentStore().removeSegment(this.$props.type, num);
      this.checkWidth();
    },
    handleMouseOver (e) {
      let num = e.currentTarget.attributes['data-num'].value;
      const segmentStore = useSegmentStore();
      if (this.$props.type === 'pipe') {
        segmentStore.setSelectedPipeNum(num, false);
      } else {
        segmentStore.setSelectedSlopeNum(num, false);
      }
    },
    handleMouseDown (e) {
      this.startMouseX = e.clientX;
      this.startScrollX = this.$refs.scroll.scrollLeft;
      this.$refs.scroll.addEventListener('mousemove', this.handleMouseMove);
      document.body.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseMove (e) {
      this.$refs.scroll.scrollTo((this.startScrollX) + (this.startMouseX - e.clientX), 0);
    },
    handleMouseUp () {
      this.$refs.scroll.removeEventListener('mousemove', this.handleMouseMove);
      document.body.removeEventListener('mouseup', this.handleMouseUp);
    }
  }
};
</script>

<style>
* {
  scrollbar-width: auto;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}
/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 11px;
  height: 11px;
}
*::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.0);
}
*::-webkit-scrollbar-thumb {
  margin: 2px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: inset 0 0 10px 10px #d0d0d0;
  border: solid 3px transparent;
}
:root {
  --desktop-seg-height: 73px;
  --mobile-seg-height: 50px;
}
</style>

<style scoped>
.layout-segment-holder {

  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-content: flex-start;
  border-bottom: .5px solid #a8a8a8;
}
.layout-segment-scroll {
  display: flex;
  z-index: 1000;
/*  overflow-x: auto;
  overflow-y: hidden;*/
/*  min-height: var(--desktop-seg-height);*/
  background-color: #fafafa;
  -webkit-box-shadow: inset 0 0 12px #bbbbbb;
  -moz-box-shadow: inset 0 0 12px #bbbbbb;
  box-shadow: inset 0 0 12px #bbbbbb;
/*  flex: 1;*/
}
.taller {
  min-height: 82px;
}
.dragHandle {
  cursor: grabbing;
}
.selected {
  background-color: #eaeaea;
}
.print-margin {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>